export const fonts = {
    primary: 'Plus Jakarta Sans, sans-serif',
    secondary: 'Inter, sans-serif',
    tertiary: 'Source Sans Pro, sans-serif',
};
export const fontWeights = {
    100: 100,
    200: 200,
    300: 300,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
    800: 800,
    900: 900,
};
